export default {
  'Casado': 1,
  'Divorciado': 2,
  'Solteiro': 3,
  'Viúvo': 4,
  'União estável': 5,
}
